import {CUSTOMER_PORTAL_CONFIG} from './local-storage-variables';

export const ENABLE_FILES_PREVIEW = 'enableFilesPreview';
export const ENABLE_HTML_EDITOR_TOOLBAR = 'enableHtmlEditorToolbar';
export const NOTIFICATION_UPDATE_PERIOD = 'notification_update_period';
export const INFO = 'info';
export const SHOW_TERMS_OF_USE = 'showTermsOfUse';
export const SHOW_PRIVACY_AND_COOKIE_POLICY = 'showPrivacyPolicy';
export const REMOVE_TAB_SR_TASKS = 'removeTabSRTasks';
export const MAIN_TICKET_FEATURE = 'mainTicketFeature';
export const REMOVE_BELL_ICONS = 'removeBellIcons';
export const REMOVE_ENVELOPE_ICONS = 'removeEnvelopeIcons';
export const COPYRIGHT = 'copyright';
export const COMPANY = 'company';
export const CHATLIB = 'chatLib';
export const TENANT = 'tenant';
export const PREFIX = 'prefix';
export const RESTURL = 'restURL';
export const CHATSERVERURL = 'chatServerUrl';
export const CHAT_SCRIPT_INIT = 'chat_script_init';
export const CHAT_SCRIPT_REMOVE = 'chat_script_remove';
export const SHOW_REPORTING = 'showReporting';
export const SHOW_CUSTOMER_STATE = 'showCustomerState';
export const SHOW_REQUEST_ACCESS_PAGE = 'showRequestAccessPage';
export const SHOW_CATEGORY_FROM_BUSINESS_SERVICE = 'categoryFromBusinessService';
export const CATEGORY_LEVEL = 'category_level';
export const MAX_FILE_UPLOAD_SIZE = 'maxFileUploadSize';

